/* MATERIAL DESIGN 3 — MAIN THEME TOGGLE */

export function initThemeToggle() {
  const toggle = document.querySelector('.theme-toggle');
  if (!toggle) return;

  const body = document.body;
  const STORAGE_KEY = 'ace-theme-preference';

  const savedTheme = localStorage.getItem(STORAGE_KEY);
  const defaultTheme = savedTheme || 'dark';

  body.classList.toggle('theme-light', defaultTheme === 'light');
  body.classList.toggle('theme-dark', defaultTheme === 'dark');
  toggle.setAttribute('aria-checked', defaultTheme === 'light');

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    const isLight = body.classList.contains('theme-light');
    const newTheme = isLight ? 'dark' : 'light';

    body.classList.toggle('theme-light', newTheme === 'light');
    body.classList.toggle('theme-dark', newTheme === 'dark');
    toggle.setAttribute('aria-checked', newTheme === 'light');

    localStorage.setItem(STORAGE_KEY, newTheme);
  });

  toggle.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggle.click();
    }
  });
}


